import HTTP from '@/common/HTTP'

import {actionTypes, mutationTypes} from './DatenpoolCategoriesTypes';

// initial state
const initialState = () => ({
  loading: false, items: [],
})

// getters
const getters = {}

// mutations
const mutations = {
  [mutationTypes.SET_LOADING](state, item) {
    state.loading = item
  },

  [mutationTypes.SET_CATEGORIES](state, item) {
    state.items = item
  },
}

// actions
const actions = {
  async [actionTypes.FETCH_CATEGORIES]({commit, dispatch}) {
    commit(mutationTypes.SET_LOADING, true)

    try {
      const result = await HTTP.get('/datenpool/categories?&size=128&sort=category')
      console.log(result)

      commit(mutationTypes.SET_CATEGORIES, result.data.content)
    } catch (e) {
      console.error(e)

      this._vm.$notify({
        group: 'app',
        title: 'Fehler',
        type: 'error',
        text: 'Kategorien konnten nicht aktualisiert werden.',
        duration: 3000
      })

      commit(mutationTypes.SET_CATEGORIES, [])
    }

    commit(mutationTypes.SET_LOADING, false)
  },

  async [actionTypes.CREATE_CATEGORY]({commit, dispatch}, newCategory) {
    commit(mutationTypes.SET_LOADING, true)

    try {
      // axios overwrites default content-type for string to text/plain, we need json
      const config = {headers: {'Content-Type': 'application/json'}};
      await HTTP.post(`/datenpool/categories/create`, newCategory, config)

      this._vm.$notify({
        group: 'app',
        title: 'Erfolgreich',
        type: 'success',
        text: 'Kategorie wurde erfolgreich erstellt.',
        duration: 3000
      })

    } catch (e) {
      console.error(e)

      this._vm.$notify({
        group: 'app',
        title: 'Fehler',
        type: 'error',
        text: 'Kategorie konnte nicht erstellt werden.',
        duration: 3000
      })
    }

    await dispatch(actionTypes.FETCH_CATEGORIES)
  },

  async [actionTypes.DELETE_CATEGORY]({commit, dispatch}, categoryId) {
    commit(mutationTypes.SET_LOADING, true)

    try {
      await HTTP.delete(`/datenpool/categories/${categoryId}/delete`)

      this._vm.$notify({
        group: 'app',
        title: 'Erfolgreich',
        type: 'success',
        text: 'Kategorie wurde erfolgreich gelöscht.',
        duration: 3000
      })

    } catch (e) {
      console.error(e)

      this._vm.$notify({
        group: 'app',
        title: 'Fehler',
        type: 'error',
        text: "Kategorie konnte nicht gelöscht werden. Zuvor darf keine Datei mehr dieser Kategorie zugewiesen sein.",
        duration: 3000
      })
    }

    await dispatch(actionTypes.FETCH_CATEGORIES)
  }
}

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/DatenpoolCategories.js